import { Box } from '@mui/material';
import styled from 'styled-components';
import { Typography, colors } from '@leapeasy/ui-kit';
import { getDemoData } from 'utils/helpers';
import { DetailsCard } from 'elements/DetailsCard';
import { hasClaimDetailValue } from 'utils/hasClaimDetailValue';

const formatLeasePortion = (leaseValue) => {
  if (!hasClaimDetailValue(leaseValue)) return null;
  return `$${parseFloat(leaseValue).toLocaleString('en-US')}`;
};

export const TenantDetails = ({ application, isDemo }) => {
  const residents = [
    {
      title: 'Resident 1',
      value: isDemo ? getDemoData('tenant-name') : application.tenant1,
    },
    {
      title: 'Resident 2',
      value: isDemo ? getDemoData('tenant-name') : application.tenant2,
    },
    {
      title: 'Resident 3',
      value: isDemo ? getDemoData('tenant-name') : application.tenant3,
    },
    {
      title: 'Resident 4',
      value: isDemo ? getDemoData('tenant-name') : application.tenant4,
    },
  ].filter((tile) => hasClaimDetailValue(tile.value));

  const portions = [
    {
      title: 'Resident 1 Portion of fees',
      value: formatLeasePortion(application.tenant1_lease),
    },
    {
      title: 'Resident 2 Portion of fees',
      value: formatLeasePortion(application.tenant2_lease),
    },
    {
      title: 'Resident 3 Portion of fees',
      value: formatLeasePortion(application.tenant3_lease),
    },
    {
      title: 'Resident 4 Portion of fees',
      value: formatLeasePortion(application.tenant4_lease),
    },
  ].filter((tile) => hasClaimDetailValue(tile.value));

  if (residents.length === 0 && portions.length === 0) return null;

  return (
    <Box display="flex" flexDirection="column" gap="10px" padding="24px">
      <Typography variant="h4" style={{ color: colors.purple[900] }}>
        Resident Information
      </Typography>

      <DetailsContainer>
        {residents.length > 0 && (
          <RowContainer>
            {residents.map((tile) => (
              <DetailsCard key={tile.title} title={tile.title} value={tile.value} />
            ))}
          </RowContainer>
        )}

        {portions.length > 0 && (
          <RowContainer>
            {portions.map((tile) => (
              <DetailsCard key={tile.title} title={tile.title} value={tile.value} width="20%" />
            ))}
          </RowContainer>
        )}
      </DetailsContainer>
    </Box>
  );
};

const DetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media screen and (max-width: ${(props) => props.theme.md}) {
    flex-direction: row;
  }
`;

const RowContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  & > div {
    width: 25%;
  }

  @media screen and (max-width: ${(props) => props.theme.md}) {
    flex-direction: column;
    & > div {
      width: 100%;
    }
  }
`;
